import { render, staticRenderFns } from "./SidebarWeshope.vue?vue&type=template&id=39c26e77&scoped=true&"
import script from "./SidebarWeshope.vue?vue&type=script&lang=ts&"
export * from "./SidebarWeshope.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarWeshope.vue?vue&type=style&index=0&id=39c26e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c26e77",
  null
  
)

export default component.exports